import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { CustomersService } from 'src/app/services/core/services/customers/customers.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';
import { debounceTime, filter, Subject } from 'rxjs';
@UntilDestroy()

@Component({
  selector: 'app-customers-list',
  templateUrl: './customers-list.component.html',
  styleUrls: ['./customers-list.component.css']
})
export class CustomersListComponent implements OnInit {
  currentPage: number = 1;
  totalPages = 0;
  filterCustomerList: any;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  search: any = '';
  private searchSubject = new Subject<string>();
  customerDetail: any;
  loadingId = null;
  syncType = null;
  selectedDropdownId: any;
  toggleActionButtons = false;
  companies: any;
  preCompanies: any;
  selectedCompanyId = null;

  constructor(
    private companyService: CompanyService,
    private customerService: CustomersService,
   
  ) { }

  customers: any;

  ngOnInit(): void {
    this.getCompanies();
    this.initializeSearch();
    this.getAllCustomers(this.currentPage);
  }

  getAllCustomers(page: any) {
    let queryParams: any = {
      limit: this.numberOfRecords,
      page,

    }
    if (this.search) {
      queryParams.search = this.search.trim();
    }
    if (this.selectedCompanyId) {
      queryParams.company = this.selectedCompanyId;
    }
    this.customerService.getCustomers(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.customers = data.results
          this.filterCustomerList = this.customers;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }
  
  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllCustomers(page);
  }

  opendetailModal(item: any) {
    this.customerDetail = item;
  }

  async onSyncCustomer(customer: any, type: any) {
    const mPull = 'Are you sure you want to overwrite customer data with QuickBooks data?';
    const mPush = 'Are you sure you want to overwrite the QuickBooks data with customer data';
    const result = await sweetAlert('Alert', type === 'pull' ? mPull : mPush, 'warning', 'Yes', 'No');
    if (!result.value) return;

    this.loadingId = customer.id;
    this.syncType = type;
    if (type === 'pull') customer.pulling = true; else customer.pushing = true;
    this.closeActionMenu(null);
    const companyId = customer.company?.id || customer.company?._id || customer.company;
    this.customerService.syncCustomer(companyId, customer.id, { isSyncFrom: type === 'pull' })
      .pipe(untilDestroyed(this)).subscribe({
        next: (data: any) => {
          this.getAllCustomers(this.currentPage);
          sweetAlert('Success', data?.message || 'Synced successfully', 'success', 'Ok');
        },
        error: (err) => {
          sweetAlert('Error', err, 'error', 'Ok');
          customer.pulling = false;
          customer.pushing = false;
          this.loadingId = null;
          this.syncType = null;
        },
        complete: () => {
          customer.pulling = false;
          customer.pushing = false;
          this.loadingId = null;
          this.syncType = null;
        }
      });
  }


  getCompanies() {
    this.companyService.getCompanies().subscribe((data: any) => {
      if (data) {
        this.companies = data.results
        this.preCompanies = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  filterCustomers() {
    this.currentPage = 1;
    this.getAllCustomers(this.currentPage);
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500),
        filter((search: any) => !search || search.length >= 3),
        untilDestroyed(this)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getAllCustomers(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }
   showActionButtons(id:any) {
    this.selectedDropdownId = id;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt:any) {
    this.selectedDropdownId = null;
    this.toggleActionButtons = false;
   }
  

}